// extracted by mini-css-extract-plugin
export var button = "styles-module--button--3o2qV";
export var disabled = "styles-module--disabled--3EwdE";
export var primary = "styles-module--primary--3IQ38";
export var negative = "styles-module--negative--2WvpF";
export var inverted = "styles-module--inverted--1yDYF";
export var secondary = "styles-module--secondary--2Nt5y";
export var textual = "styles-module--textual--1lkVx";